import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import DIRECTION_VERTICAL from 'constants/DIRECTION_VERTICAL';
import Section from 'components/common/Section';
import InsulinPatternChart from 'components/charts/InsulinPatternChart';
import useReportInsulinPattern from 'hooks/communication/useReportInsulinPattern';
import usePaging from 'hooks/tables/usePaging';
import Recoil from 'recoil';
import * as AppStore from 'stores/AppStore';
import React from 'react';
import useSetChartData from 'hooks/app/useSetChartData';

export default function InsulinPattern(props) {
  const {
    duration,
    ...rest
  } = props;

  const {
    requestReportInsulinPattern,
  } = useReportInsulinPattern();

  const [chartData, setChartData] = Recoil.useRecoilState(AppStore.assets.data('InsulinPatternTimeList'));
  const [insulin_pattern_time_graph, setGraphList] = React.useState([]);
  const [insulin_pattern_time_list, setTimeList] = React.useState([]);
  const dosis = React.useMemo(() => {
    const bolus = [];
    const base = [];
    insulin_pattern_time_list.forEach(item => {
      const {
        time_zone_tp_cd,
        bolus_amt,
        giju_amt,
      } = item;
      bolus.push(bolus_amt);
      base.push(giju_amt);
    });
    return { bolus, base };
  }, [insulin_pattern_time_list]);

  const period_start = Recoil.useRecoilValue(AppStore.assets.period_start);
  const period_end = Recoil.useRecoilValue(AppStore.assets.period_end);
  const patient_no = Recoil.useRecoilValue(AppStore.assets.patient_no);
  React.useEffect(() => {
    requestReportInsulinPattern({
      patient_no,
      search_start_time: period_start,
      search_end_time: period_end,
    }, (success, data) => {
      if (success) {
        setChartData(() => ({ list: data.insulin_pattern_time_list }));
        setGraphList(() => data.insulin_pattern_time_graph);
        setTimeList(() => data.insulin_pattern_time_list);
      } else {
        setChartData(() => ({ list: [] }));
        setGraphList(() => []);
        setTimeList(() => []);
      }
    });
  }, [patient_no, period_end, period_start, requestReportInsulinPattern, setChartData]);

  return (
    <Section
      {...ex('InsulinPattern', props)}
      {...{
        caption: T('인슐린 통계'),
        direction: DIRECTION_VERTICAL,
      }}
    >
      <InsulinPatternChart {...{ insulin_pattern_time_graph, duration, chartData }} />
      <table>
        <thead>
          <tr>
            <th>
              <div>
                {T('구분')}
              </div>
            </th>
            <th>
              <div>
                {T('새벽(0~6H)')}
              </div>
            </th>
            <th>
              <div>
                {T('오전(6~12H)')}
              </div>
            </th>
            <th>
              <div>
                {T('오후(12~18H)')}
              </div>
            </th>
            <th>
              <div>
                {T('저녁(18~24H)')}
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div>
                {T('평균 기저 투여량 (U)')}
              </div>
            </td>
            {dosis.base.map((value, index) => (
              <td key={index}>
                <div>
                  {value}
                </div>
              </td>
            ))}
          </tr>

          <tr>
            <td>
              <div>
                {T('평균 볼루스 투여량 (U)')}
              </div>
            </td>
            {dosis.bolus.map((value, index) => (
              <td key={index}>
                <div>
                  {value}
                </div>
              </td>
            ))}
          </tr>

        </tbody>
      </table>
    </Section >
  );
}
